<script setup lang="ts">
import logoUrl from '~/assets/images/logos/Teachme_Check_logo.svg?url'

defineProps<{
  height: number
}>()
</script>

<template>
  <img :src="logoUrl" :style="{ height: `${height}px` }" />
</template>
